// import { Component, Input, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FaIconComponent, FaIconLibrary } from '@fortawesome/angular-fontawesome';
// import { faSearchMinus, faSearchPlus } from '@fortawesome/free-solid-svg-icons';

// @Component({
//   selector: 'app-image-viewer',
//   standalone: true,
//   imports: [CommonModule, FaIconComponent],
//   templateUrl: './image-viewer.component.html',
//   styleUrls: ['./image-viewer.component.css']
// })
// export class ImageViewerComponent implements OnInit {
//   @Input() imageUrl: string = '';
//   @Input() show: boolean = false;
//   @Input() closeModal!: () => void;

//   @ViewChild('imageElement') imageElement!: ElementRef<HTMLImageElement>;
//   constructor(library: FaIconLibrary) { 
//     library.addIcons(faSearchPlus, faSearchMinus);
//   }

//   zoomLevel = 1;
//   maxZoom = 3;
//   minZoom = 1;
//   position = { x: 0, y: 0 };
//   isDragging = false;
//   lastMouse = { x: 0, y: 0 };

//   ngOnInit(): void {}

//   onImageLoad() {
//     this.zoomLevel = 1;
//     this.position = { x: 0, y: 0 };
//   }

//   zoomIn() {
//     if (this.zoomLevel < this.maxZoom) {
//       this.zoomLevel += 0.2;
//     }
//   }

//   zoomOut() {
//     if (this.zoomLevel > this.minZoom) {
//       this.zoomLevel -= 0.2;
//       if (this.zoomLevel < this.minZoom) this.zoomLevel = this.minZoom;
//       if (this.zoomLevel === 1) this.position = { x: 0, y: 0 };
//     }
//   }

//   resetZoom() {
//     this.zoomLevel = 1;
//     this.position = { x: 0, y: 0 };
//   }

//   startDrag(event: MouseEvent) {
//     if (this.zoomLevel > 1) {
//       this.isDragging = true;
//       this.lastMouse = { x: event.clientX, y: event.clientY };
//     }
//   }

//   drag(event: MouseEvent) {
//     if (this.isDragging) {
//       const deltaX = event.clientX - this.lastMouse.x;
//       const deltaY = event.clientY - this.lastMouse.y;
//       this.lastMouse = { x: event.clientX, y: event.clientY };

//       const img = this.imageElement.nativeElement;
//       const container = img.parentElement!;
//       const imgWidth = img.offsetWidth * this.zoomLevel;
//       const imgHeight = img.offsetHeight * this.zoomLevel;
//       const containerWidth = container.offsetWidth;
//       const containerHeight = container.offsetHeight;

//       let newX = this.position.x + deltaX;
//       let newY = this.position.y + deltaY;

//       // Restrict dragging inside the image boundaries
//       const maxX = (imgWidth - containerWidth) / 2;
//       const maxY = (imgHeight - containerHeight) / 2;

//       if (newX > maxX) newX = maxX;
//       if (newX < -maxX) newX = -maxX;
//       if (newY > maxY) newY = maxY;
//       if (newY < -maxY) newY = -maxY;

//       this.position = { x: newX, y: newY };
//     }
//   }

//   stopDrag() {
//     this.isDragging = false;
//   }

//   @HostListener('document:keyup', ['$event'])
//   handleKeyboard(event: KeyboardEvent) {
//     if (!this.show) return;
//     if (event.key === '+') this.zoomIn();
//     if (event.key === '-') this.zoomOut();
//     if (event.key === 'Escape') this.closeModal();
//   }
// }


import { Component, Input, HostListener, ElementRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconComponent, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faSearchMinus, faSearchPlus, faUndo, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

interface ImageSlide {
  url: string;
  direction: string;
}

@Component({
    selector: 'app-image-viewer',
    imports: [CommonModule, FaIconComponent],
    templateUrl: './image-viewer.component.html',
    styleUrls: ['./image-viewer.component.css']
})
export class ImageViewerComponent implements OnChanges {
  @Input() images: ImageSlide[] = [];
  @Input() show: boolean = false;
  @Input() closeModal!: () => void;

  @ViewChild('imageElement') imageElement!: ElementRef<HTMLImageElement>;

  currentSlideIndex = 0;
  failedSlides = new Set<number>();
  zoomLevel = 1;
  maxZoom = 4;
  minZoom = 1;
  position = { x: 0, y: 0 };
  isDragging = false;
  lastMouse = { x: 0, y: 0 };
  private lastTouchDistance: number | null = null;

  constructor(library: FaIconLibrary) { 
    library.addIcons(faSearchPlus, faSearchMinus, faUndo, faChevronLeft, faChevronRight);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Reset slide index and zoom when images or show modal state changes
    if (changes['images'] || changes['show']) {
      if (this.show && this.images.length > 0) {
        this.currentSlideIndex = 0;
        this.failedSlides = new Set<number>();
        this.resetZoom();
      }
    }
  }

  get currentImage(): ImageSlide {
    return this.images[this.currentSlideIndex] || { url: '', direction: '' };
  }

  onImageLoad() {
    this.failedSlides.delete(this.currentSlideIndex);
    this.resetZoom();
  }

  onImageError() {
    this.failedSlides.add(this.currentSlideIndex);
    this.resetZoom();
  }

  get currentImageFailed(): boolean {
    return this.failedSlides.has(this.currentSlideIndex);
  }

  zoomIn() {
    if (this.zoomLevel < this.maxZoom) {
      this.zoomLevel += 0.2;
    }
  }

  zoomOut() {
    if (this.zoomLevel > this.minZoom) {
      this.zoomLevel -= 0.2;
      if (this.zoomLevel < this.minZoom) this.zoomLevel = this.minZoom;
      if (this.zoomLevel === 1) this.position = { x: 0, y: 0 };
    }
  }

  resetZoom() {
    this.zoomLevel = 1;
    this.position = { x: 0, y: 0 };
  }

  toggleZoom(event: MouseEvent) {
    if (this.zoomLevel === 1) {
      this.zoomLevel = 2;
      this.position = { x: 0, y: 0 };
    } else {
      this.resetZoom();
    }
  }

  previousSlide() {
    if (this.currentSlideIndex > 0) {
      this.currentSlideIndex--;
      this.resetZoom();
    }
  }

  nextSlide() {
    if (this.currentSlideIndex < this.images.length - 1) {
      this.currentSlideIndex++;
      this.resetZoom();
    }
  }

  startDrag(event: MouseEvent) {
    if (this.zoomLevel > 1) {
      this.isDragging = true;
      this.lastMouse = { x: event.clientX, y: event.clientY };
    }
  }

  drag(event: MouseEvent) {
    if (this.isDragging) {
      this.updatePosition(event.clientX - this.lastMouse.x, event.clientY - this.lastMouse.y);
      this.lastMouse = { x: event.clientX, y: event.clientY };
    }
  }

  stopDrag() {
    this.isDragging = false;
  }

  onTouchStart(event: TouchEvent) {
    if (event.touches.length === 2) {
      this.lastTouchDistance = this.getTouchDistance(event.touches);
    } else if (event.touches.length === 1 && this.zoomLevel > 1) {
      this.isDragging = true;
      this.lastMouse = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
  }

  onTouchMove(event: TouchEvent) {
    if (event.touches.length === 2 && this.lastTouchDistance) {
      const newDistance = this.getTouchDistance(event.touches);
      const scaleChange = newDistance / this.lastTouchDistance;
      this.zoomLevel = Math.min(this.maxZoom, Math.max(this.minZoom, this.zoomLevel * scaleChange));
      this.lastTouchDistance = newDistance;
    } else if (event.touches.length === 1 && this.isDragging) {
      const deltaX = event.touches[0].clientX - this.lastMouse.x;
      const deltaY = event.touches[0].clientY - this.lastMouse.y;
      this.updatePosition(deltaX, deltaY);
      this.lastMouse = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
  }

  onTouchEnd(event: TouchEvent) {
    if (event.touches.length < 2) {
      this.lastTouchDistance = null;
    }
    if (event.touches.length === 0) {
      this.isDragging = false;
    }
  }

  private getTouchDistance(touches: TouchList): number {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  private updatePosition(deltaX: number, deltaY: number) {
    const img = this.imageElement.nativeElement;
    const container = img.parentElement!;
    const imgWidth = img.offsetWidth * this.zoomLevel;
    const imgHeight = img.offsetHeight * this.zoomLevel;
    const containerWidth = container.offsetWidth;
    const containerHeight = container.offsetHeight;

    let newX = this.position.x + deltaX;
    let newY = this.position.y + deltaY;

    const maxX = (imgWidth - containerWidth) / 2;
    const maxY = (imgHeight - containerHeight) / 2;

    if (newX > maxX) newX = maxX;
    if (newX < -maxX) newX = -maxX;
    if (newY > maxY) newY = maxY;
    if (newY < -maxY) newY = -maxY;

    this.position = { x: newX, y: newY };
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboard(event: KeyboardEvent) {
    if (!this.show) return;
    if (event.key === '+') this.zoomIn();
    if (event.key === '-') this.zoomOut();
    if (event.key === 'Escape') this.closeModal();
    if (event.key === 'ArrowLeft') this.previousSlide();
    if (event.key === 'ArrowRight') this.nextSlide();
  }
}
